/**
 * Nepali locale for phone-numbers page.
 * Export is the "phoneNumbers" subtree for host i18n merge.
 */
import type { PhoneNumbersLocale } from './en'

export const phoneNumbersNe = {
  list: {
    title: `फोन नम्बरहरू`,
    serverGroup: `सर्भर समूह:`,
    searchPlaceholder: `खोज्नुहोस्...`,
    loading: `फोन नम्बरहरू लोड हुँदैछ...`,
    error: `फोन नम्बरहरू लोड गर्न असफल`,
    empty: `यो पीबीएक्सको लागि फोन नम्बरहरू भेटिएनन्`,
    noResults: `तपाईंको खोजसँग मिल्ने फोन नम्बर छैन`,
    columnName: `नाम`,
    columnNumber: `नम्बर`,
    columnExtension: `एक्सटेन्सन`,
    columnCallerId: `कलर ID`,
    columnType: `प्रकार`,
    columnTollFree: `टोल फ्री`,
    columnSms: `एसएमएस`,
    columnE911: `e911`,
    columnVoiceProvider: `भ्वाइस प्रदायक`,
    columnSmsProvider: `एसएमएस प्रदायक`,
    columnProviders: `प्रदायकहरू`,
    columnStatus: `स्थिति`,
    columnUpdated: `अद्यावधिक`,
    yes: `हो`,
    no: `होइन`,
    smsActive: `सक्रिय`,
    e911Verified: `प्रमाणित`,
    createButton: `+ फोन नम्बर सिर्जना गर्नुहोस्`,
    createDisabledTooltip: `फोन नम्बर सिर्जना फोन टोलीद्वारा व्यवस्थापन गरिन्छ`,
    filterButton: `फिल्टरहरू`,
    copyNumber: `नम्बर प्रतिलिपि गर्नुहोस्`,
    toast: {
      createSuccess: `फोन नम्बर सिर्जना गरियो`,
      createFailed: `फोन नम्बर सिर्जना गर्न असफल`,
      copied: `नम्बर क्लिपबोर्डमा प्रतिलिपि गरियो`,
      copyFailed: `नम्बर प्रतिलिपि गर्न असफल भयो`,
    },
  },
  filters: {
    status: `स्थिति`,
    allStatuses: `सबै`,
    type: `प्रकार`,
    allTypes: `सबै`,
    voiceProvider: `भ्वाइस प्रदायक`,
    smsProvider: `एसएमएस प्रदायक`,
    allProviders: `सबै`,
    tollFree: `टोल फ्री`,
    any: `कुनै पनि`,
    showDeleted: `मेटिएका देखाउनुहोस्`,
    clearAll: `फिल्टरहरू हटाउनुहोस्`,
  },
  types: {
    callerId: `कलर ID`,
    smsOnly: `एसएमएस मात्र`,
    standard: `मानक`,
    temporary: `अस्थायी`,
  },
  bulk: {
    title: `थोक स्थिति अपडेट`,
    description: `चयन गरिएका फोन नम्बर(हरू)को स्थिति अपडेट गर्नुहोस्।`,
    selected: `{{count}} चयन गरिएको`,
    apply: `लागू गर्नुहोस्`,
    updateStatus: `स्थिति अपडेट`,
    clearSelection: `हटाउनुहोस्`,
    maxExceeded: `एक पटकमा अधिकतम 25`,
    selectAll: `सबै फोन नम्बरहरू चयन गर्नुहोस्`,
    selectRow: `{{number}} चयन गर्नुहोस्`,
    toast: {
      success: `स्थिति सफलतापूर्वक अपडेट गरियो`,
      failed: `थोक स्थिति अपडेट गर्न असफल भयो`,
    },
    results: {
      titleSuccess: `थोक अपडेट पूरा भयो`,
      titleAllFailed: `थोक अपडेट असफल`,
      titlePartial: `थोक अपडेट आंशिक रूपमा पूरा भयो`,
      summarySuccess: `{{count}} फोन नम्बर(हरू) सफलतापूर्वक अपडेट गरियो।`,
      summaryAllFailed: `सबै {{count}} फोन नम्बर(हरू) अपडेट गर्न असफल भयो।`,
      summaryPartial: `{{totalCount}} मध्ये {{successCount}} अपडेट भयो। {{failedCount}} असफल:`,
      colNumber: `नम्बर`,
      colStatus: `हालको स्थिति`,
      colError: `त्रुटि`,
      close: `बन्द गर्नुहोस्`,
    },
  },
  detail: {
    loading: `फोन नम्बर लोड हुँदैछ...`,
    error: `फोन नम्बर लोड गर्न असफल`,
    backToList: `सूचीमा फर्कनुहोस्`,
    editButton: `फोन नम्बर सम्पादन`,
    deleteTitle: `फोन नम्बर मेटाउनुहोस्`,
    deleteButton: `मेटाउनुहोस्`,
    deleteConfirmation: `यसले फोन नम्बर सफ्ट-डिलिट गर्नेछ। आवश्यक भएमा पछि पुनर्स्थापना गर्न सकिन्छ। के तपाईं निश्चित हुनुहुन्छ?`,
    restoreButton: `पुनर्स्थापना`,
    noopSaveButton: `पुन: सुरक्षित`,
    deleted: `मेटिएको`,
    sectionGeneral: `सामान्य जानकारी`,
    sectionProviders: `प्रदायकहरू`,
    sectionRouting: `राउटिङ`,
    sectionSms: `एसएमएस`,
    sectionE911: `E911 जानकारी`,
    sectionTimestamps: `टाइमस्ट्याम्प`,
    sectionSmsDiagnostics: `Telnyx एसएमएस निदान`,
    diagnosticWarning: `चेतावनी`,
    fieldName: `नाम`,
    fieldNumber: `नम्बर`,
    fieldPbx: `पीबीएक्स`,
    fieldType: `प्रकार`,
    fieldCallerId: `कलर ID`,
    fieldExtension: `एक्सटेन्सन`,
    fieldTollFree: `टोल फ्री`,
    fieldCountryCode: `देश कोड`,
    fieldLocalPresence: `स्थानीय उपस्थिति`,
    fieldCampaignId: `अभियान ID`,
    fieldVoiceProvider: `भ्वाइस प्रदायक`,
    fieldSmsProvider: `एसएमएस प्रदायक`,
    fieldSmsEnabled: `एसएमएस सक्षम`,
    fieldSmsStatus: `एसएमएस स्थिति`,
    fieldSmsRelay: `एसएमएस रिले`,
    fieldSmsRelayIntegration: `एसएमएस रिले इन्टिग्रेसन`,
    fieldSmsGroup: `एसएमएस समूह`,
    fieldE911Status: `E911 स्थिति`,
    fieldE911Address: `ठेगाना`,
    fieldE911Address2: `ठेगाना 2`,
    fieldE911City: `शहर`,
    fieldE911State: `राज्य`,
    fieldSendFaxesFrom: `फ्याक्स पठाउने नम्बर`,
    usePbxDefault: `पीबीएक्स पूर्वनिर्धारित प्रयोग गर्नुहोस्`,
    fieldPbxServerGroup: `पीबीएक्स सर्भर समूह`,
    fieldSourceTracking: `स्रोत ट्र्याकिङ`,
    fieldStatus: `स्थिति`,
    fieldE911PostalCode: `हुलाक कोड`,
    fieldCreatedAt: `सिर्जना मिति`,
    fieldUpdatedAt: `अद्यावधिक मिति`,
    viewInProvider: `{{provider}} मा हेर्नुहोस्`,
    sectionMetrics: `मेट्रिक्स`,
    fieldCallStats: `कल तथ्याङ्क`,
    callStatsLink: `कल तथ्याङ्क`,
    on: `सक्रिय`,
    off: `बन्द`,
    registered: `दर्ता भएको`,
    inactive: `निष्क्रिय`,
    notRegistered: `दर्ता नभएको`,
    toast: {
      updateSuccess: `फोन नम्बर अद्यावधिक गरियो`,
      updateFailed: `फोन नम्बर अद्यावधिक गर्न असफल`,
      deleteSuccess: `फोन नम्बर मेटाइयो`,
      deleteFailed: `फोन नम्बर मेटाउन असफल`,
      restoreSuccess: `फोन नम्बर पुनर्स्थापना गरियो`,
      restoreFailed: `फोन नम्बर पुनर्स्थापना गर्न असफल`,
      noopSaveSuccess: `साइड इफेक्टहरू पुनः ट्रिगर गरियो`,
      noopSaveFailed: `पुनः सेभ गर्न सकिएन`,
    },
  },
  edit: {
    title: `फोन नम्बर सम्पादन`,
    numberLabel: `नम्बर`,
    nameLabel: `नाम`,
    namePlaceholder: `फोन नम्बर नाम`,
    typeLabel: `प्रकार`,
    statusLabel: `स्थिति`,
    selectStatus: `— स्थिति छान्नुहोस् —`,
    voiceProviderLabel: `भ्वाइस प्रदायक`,
    smsProviderLabel: `एसएमएस प्रदायक`,
    selectProvider: `— छान्नुहोस् —`,
    unassigned: `तोकिएको छैन`,
    callerIdLabel: `कलर ID`,
    sendFaxesFromLabel: `फ्याक्स पठाउने नम्बर`,
    usePbxDefault: `पीबीएक्स पूर्वनिर्धारित प्रयोग गर्नुहोस्`,
    extensionLabel: `एक्सटेन्सन`,
    extensionPlaceholder: `एक्सटेन्सन UUID`,
    extensionHelp: `फोन नम्बरको लागि वैकल्पिक एक्सटेन्सन।`,
    noExtension: `कुनै पनि छैन`,
    sourceTrackingLabel: `स्रोत ट्र्याकिङ`,
    sourceTrackingHelp: `आगमन कलहरूको लागि कलर ID अगाडि ६ वटासम्म अक्षरहरू जोड्नुहोस्। यो सामान्यतया विज्ञापन अभियानहरू ट्र्याक गर्न प्रयोग गरिन्छ।`,
    localPresenceLabel: `स्थानीय उपस्थिति`,
    localPresenceHelp: `स्थानीय उपस्थिति समूहहरूले नम्बरहरूको पूल सिर्जना गर्छन् जसबाट स्थानीय उपस्थिति सक्षम लाइन एक्सटेन्सनले कल गर्न सक्छ ताकि कल प्राप्तकर्तालाई स्थानीय देखिन्छ।`,
    e911Section: `आपतकालीन 911 (E911) सेटिङहरू`,
    e911AddressLabel: `ठेगाना`,
    e911Address2Label: `अपार्टमेन्ट/सुइट`,
    e911CityLabel: `शहर`,
    e911StateLabel: `राज्य/प्रान्त`,
    e911PostalCodeLabel: `हुलाक कोड`,
    e911Disclaimer: `E911 उत्तर अमेरिकामा कलरको स्थान स्वचालित रूपमा 911 डिस्प्याचरहरूलाई प्रदान गर्न प्रयोग हुने प्रणाली हो। कृपया यो जानकारी सही छ भनी सुनिश्चित गर्नुहोस् — कसैको जीवन यसमा निर्भर हुन सक्छ।`,
    smsSection: `एसएमएस सेटिङहरू`,
    smsEnabledLabel: `एसएमएस सक्षम`,
    smsEnabledWarning: `चेतावनी: एसएमएस सक्षम गर्दा यो नम्बरको eSPID पोर्ट-इन अनुरोध ट्रिगर हुनेछ, जसले ग्राहकको लागि एसएमएस डाउनटाइम हुन सक्छ। अगाडि बढ्नु अघि कृपया यो इच्छित कार्य हो भनी सुनिश्चित गर्नुहोस्।`,
    smsRelayLabel: `एसएमएस रिले`,
    smsRelayIntegrationLabel: `एसएमएस रिले एकीकरण`,
    smsRelayIntegrationDisabledHelp: `एकीकरण छान्न एसएमएस रिले सक्षम गर्नुहोस्।`,
    noIntegration: `कुनै पनि छैन`,
    integrationSearchPlaceholder: `एकीकरणहरू खोज्नुहोस्...`,
    integrationSearchAriaLabel: `नामद्वारा एसएमएस रिले एकीकरणहरू खोज्नुहोस्`,
    noIntegrationMatches: `त्यो खोजीसँग मेल खाने कुनै एकीकरण छैन।`,
    campaignIdLabel: `अभियान ID`,
    campaignIdHelp: `एसएमएस पठाउनको लागि आवश्यक। यो मान सेट गर्नु अघि, सम्बन्धित प्रदायकमा अभियान ID यो नम्बरमा लिंक गरिएको सुनिश्चित गर्नुहोस्। त्यसो नगरेमा सेवा अवरोध, डेलिभरी विफलता, र/वा जरिवाना हुन सक्छ।`,
    titleWithNumber: `फोन नम्बर सम्पादन — {{number}}`,
    advancedSection: `उन्नत`,
    e911NotConfigured: `कन्फिगर गरिएको छैन`,
    extensionSearchPlaceholder: `एक्स्टेन्सनहरू खोज्नुहोस्...`,
    extensionSearchAriaLabel: `नाम वा नम्बरद्वारा एक्स्टेन्सनहरू खोज्नुहोस्`,
    noExtensionMatches: `त्यो खोजसँग मेल खाने एक्स्टेन्सन छैन।`,
    cancel: `रद्द`,
    save: `सुरक्षित गर्नुहोस्`,
  },
  create: {
    title: `फोन नम्बर सिर्जना`,
    numberLabel: `फोन नम्बर`,
    numberPlaceholder: `+1234567890`,
    numberHelp: `देश कोड समावेश गर्नुपर्छ (जस्तै US को लागि +18015551234, UK को लागि +442079460958)।`,
    numberHelpWithPrefix: `देश कोड बिना नम्बर प्रविष्ट गर्नुहोस्।`,
    selectType: `— प्रकार छान्नुहोस् —`,
    saveButton: `सिर्जना`,
    createMore: `थप सिर्जना`,
    searchStateProvince: `खोज्नुहोस्...`,
    noStateProvinceMatches: `मेल खाँदैन`,
  },
  validation: {
    numberRequired: `फोन नम्बर आवश्यक छ`,
    numberInvalid: `मान्य फोन नम्बर प्रविष्ट गर्नुहोस् (जस्तै +1 (801) 555-1234)`,
    numberInvalidNational: `मान्य फोन नम्बर प्रविष्ट गर्नुहोस् (उदा. (801) 555-1234)`,
    numberMissingCountryCode: `फोन नम्बरमा देश कोड समावेश हुनुपर्छ (जस्तै US को लागि +1, UK को लागि +44)`,
    nameRequired: `नाम आवश्यक छ`,
    typeRequired: `प्रकार आवश्यक छ`,
    statusRequired: `स्थिति आवश्यक छ`,
    voiceProviderRequired: `भ्वाइस प्रदायक आवश्यक छ`,
    callerIdTooLong: `अधिकतम 15 अक्षर`,
    callerIdInvalidChars: `अक्षर, संख्या र खाली ठाउँ मात्र अनुमति छ`,
    callerIdAllDigits: `सबै अंकहरू हुन सक्दैन`,
    campaignIdFormat: `ठीक 7 अक्षरांक हुनुपर्छ`,
    sourceTrackingFormat: `1-6 अक्षरांक मात्र`,
    e911Incomplete: `कुनै पनि E911 फिल्ड भरिएमा ठेगाना, शहर, राज्य, र हुलाक कोड सबै आवश्यक छन्`,
  },
  pagination: {
    resultsPerPage: `प्रति पृष्ठ परिणाम:`,
    previousPage: `अघिल्लो पृष्ठ`,
    nextPage: `अर्को पृष्ठ`,
    jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
    all: `सबै`,
    recordRange: `{{start}}-{{end}} मध्ये {{total}}`,
    recordRangeEmpty: `0 मध्ये 0`,
  },
} satisfies PhoneNumbersLocale
